module.exports = __webpack_public_path__ + "static/media/BrooklynApartmentINTA0003b_bg_clean_v001.b5cfe47b.webp";